import React, { CSSProperties, ReactNode } from 'react';
import { Radio } from 'antd';
import './style.css';

/**
 * Props for the FormRadioButton component.
 */
interface FormRadioButtonProps {
  /** Label text displayed next to the radio button. */
  label: string;
  /** Optional icon displayed next to the label. */
  icon?: ReactNode;
  /** The value associated with the radio button. */
  value: string | number | boolean;
  /** Custom styles for the content inside the radio button. */
  radioButtonContentStyle?: CSSProperties;
  /** Optional ID for the radio button element. */
  id?: string;
  /** Click event handler for the radio button. */
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

/**
 * A customizable radio button component with an optional icon and styling.
 *
 * @param {FormRadioButtonProps} props - The component props.
 * @returns {JSX.Element} The rendered FormRadioButton component.
 */
const FormRadioButton: React.FC<FormRadioButtonProps> = ({
  label,
  icon,
  value,
  radioButtonContentStyle = {},
  id = '',
  onClick,
}) => {
  return (
    <Radio id={id} value={value} onClick={onClick}>
      <div id="radioLabelMain" className="radioLabelMain" style={radioButtonContentStyle}>
        <div className="radioLabel">{label}</div>
        <div>{icon}</div>
      </div>
    </Radio>
  );
};

export default FormRadioButton;
